export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			required: true,
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Categoria',
	plural_model_name_spanish: 'Categorias',
	create_model_name_spanish: 'Nueva categoria',
	text_delete: 'la',
}